// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-tasks-api';

export const useListDexTasks: typeof hookExports.useListDexTasks = hookExports.useListDexTasks;
export const useLazyListDexTasks: typeof hookExports.useLazyListDexTasks =
  hookExports.useLazyListDexTasks;
export const useGetDexTask: typeof hookExports.useGetDexTask = hookExports.useGetDexTask;
export const useLazyGetDexTask: typeof hookExports.useLazyGetDexTask =
  hookExports.useLazyGetDexTask;
export const useCreateDexTask: typeof hookExports.useCreateDexTask = hookExports.useCreateDexTask;
export const useUpdateDexTask: typeof hookExports.useUpdateDexTask = hookExports.useUpdateDexTask;
export const useUpdateDexTaskStatus: typeof hookExports.useUpdateDexTaskStatus =
  hookExports.useUpdateDexTaskStatus;
export const useDeleteDexTask: typeof hookExports.useDeleteDexTask = hookExports.useDeleteDexTask;
